export const GET_DEPLOY_LOGS_REQUEST = 'GET_DEPLOY_LOGS_REQUEST'
export const GET_DEPLOY_LOGS_SUCCESS = 'GET_DEPLOY_LOGS_SUCCESS'
export const GET_DEPLOY_LOGS_FAILED = 'GET_DEPLOY_LOGS_FAILED'

export const SET_CURRENT_DEPLOY_LOG = 'SET_CURRENT_DEPLOY_LOG'
